<template>
  <component :is="statusData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="statusData === undefined">
      <h4 class="alert-heading">獲取商品狀態時出錯</h4>
      <div class="alert-body">
        找不到相關商品狀態記錄。請查看
        <b-link class="alert-link" :to="{ name: 'types-list' }">
          商品狀態列表
        </b-link>
      </div>
    </b-alert>
    <status-edit-tab-information
      v-if="statusData"
      :status-data="statusData"
      class="p-sm-2"
      @refetch-data="refetchData"
    />

  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import statusStoreModule from "../statusStoreModule";
import statusEditTabInformation from "./statusEditTabInformation.vue";

export default {
  components: {
    statusEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const statusData = ref({
      id: 0,
      name: '',
      sort_order: 1,
      is_active:1 
    });

    const status = {
      id: 0,
      name: '',
      sort_order: 1,
      is_active:1
    };

    const status_APP_STORE_MODULE_NAME = "status";

    if (!store.hasModule(status_APP_STORE_MODULE_NAME))
      store.registerModule(status_APP_STORE_MODULE_NAME, statusStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(status_APP_STORE_MODULE_NAME))
        store.unregisterModule(status_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "product-status-create") {
        statusData.value = status;
      } else {
        console.log("fetchStatus", router.currentRoute.params.id)
        store
          .dispatch("status/fetchStatus", { id: router.currentRoute.params.id })
          .then((response) => {
            statusData.value = response.data.product_status;
          })
          .catch((error) => {
            console.log("error when fetching status", error);
            if (error.response.status === 404) {
              statusData.value = undefined;
            }
          });
      }
    };

    onMounted(() => {
      refetchData();
    });

    return {
      statusData,
      refetchData,
    };
  },
};
</script>
